(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/page-category-games-standalone/assets/javascripts/momang-categories-menu.js') >= 0) return;  svs.modules.push('/components/casino-react/page-category-games-standalone/assets/javascripts/momang-categories-menu.js');

'use strict';

const {
  useMemo
} = React;
const {
  Link,
  useLocation
} = ReactRouterDOM;
const {
  ItemsMenu,
  IconItem
} = svs.ui.ReactItemsMenu;

function MomangCategoriesMenu(_ref) {
  let {
    categories,
    defaultCategory
  } = _ref;
  const location = useLocation();
  const selectedCategory = useMemo(() => categories.find(category => category.urlPath === location.pathname) || defaultCategory, [location.pathname, defaultCategory, categories]);
  return React.createElement("div", {
    className: "margin-xs-top-2 margin-sm-top-2 margin-md-top-4 margin-xs-bottom-1 margin-sm-bottom-2"
  }, React.createElement(ItemsMenu, {
    ariaLabel: "Meny f\xF6r kategorier",
    branding: "momang",
    centered: true,
    hiddenScrollbar: true,
    useScrollFaders: true,
    useScrollHelpers: true
  }, categories.map(category => React.createElement(IconItem, {
    alignment: "vertical",
    className: "js-item-one",
    Component: Link,
    hasIconCircle: true,
    hasUnderline: false,
    iconName: category.icon,
    isSelected: category.systemName === selectedCategory.systemName,
    key: category.urlPath,
    label: category.title,
    to: category.urlPath
  }))));
}
setGlobal('svs.components.casino_react.pageCategoryGamesStandalone.CategoriesMenu', MomangCategoriesMenu);

 })(window);